import { getMillisecond } from '@Utils/getMillisecond';

export const ACTION_DONE_DURATION = getMillisecond(3);
export const ACTION_ERROR_DURATION = getMillisecond(5);
export const ACTION_WARNING_DURATION = getMillisecond(5);
export const ACTION_INFO_DURATION = getMillisecond(10);

export const TOOLTIP_OPEN_DELAY_DURATION = getMillisecond(0.6);
export const TOOLTIP_CLOSE_DELAY_DURATION = getMillisecond(0.1);
